import { queryOptions } from '@tanstack/react-query';

import { pastExportsApi } from './pastExports.api';

export const pastExportsOptions = {
  all: () => ['dataHub', 'pastExports'] as const,
  lists: () => [...pastExportsOptions.all(), 'list'] as const,
  details: () => [...pastExportsOptions.all(), 'detail'] as const,
  detail: (exportId: string) => [...pastExportsOptions.details(), exportId] as const,

  list: () =>
    queryOptions({
      queryKey: pastExportsOptions.lists(),
      queryFn: () => pastExportsApi.fetchPastExports(),
      // eslint-disable-next-line sonarjs/function-return-type -- TanStack Query refetchInterval expects number | false
      refetchInterval: query => {
        const data = query.state.data;
        const hasOngoing = data?.some(item => item.exportStatus === 'ongoing');
        return hasOngoing ? 5000 : false;
      }
    })
};
